import { render } from "./Error.vue?vue&type=template&id=b077bf3e&scoped=true"
import script from "./Error.vue?vue&type=script&lang=js"
export * from "./Error.vue?vue&type=script&lang=js"

import "./Error.vue?vue&type=style&index=0&id=b077bf3e&lang=scss&scoped=true"

import exportComponent from "/www/wwwroot/app.lensmark.kz/mini-app-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b077bf3e"]])

export default __exports__